import { lighten } from 'polished';
import type { Colors, DefaultTheme } from 'styled-components';
import { setAlpha } from '../utils';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  ...darkColors,
};

const customButtonColor: Colors['green'] = {
  default: '#4080BF',
  lighten: lighten(0.1, '#4080BF'),
  dim: setAlpha(0.4, '#4080BF'),
  mute: setAlpha(0.1, '#4080BF'),
};

export const DarkQ9Theme: DefaultTheme = mapDarkTheme(colors, {
  name: 'Dark',

  backgroundPositiveButton: customButtonColor.default,
  backgroundPositiveButtonHover: customButtonColor.lighten,
  backgroundPositiveButtonFocus: customButtonColor.lighten,
  backgroundPositiveButtonActive: customButtonColor.default,
  backgroundPositiveButtonDisabled: setAlpha(0.5, customButtonColor.default),
});
